/**
 * The dev-tap trigger contract, in its own dependency-free module so
 * MUI-free boot surfaces (BootScreen) and MUI surfaces
 * (ConnectionRecoveryPage) can tag their version text without importing the
 * diagnostics implementation.
 */

export const BOOT_DIAGNOSTICS_TRIGGER_ATTRIBUTE = 'data-boot-diagnostics-trigger';
export const BOOT_DIAGNOSTICS_TRIGGER_SELECTOR = `[${BOOT_DIAGNOSTICS_TRIGGER_ATTRIBUTE}]`;
export const BOOT_DIAGNOSTICS_TAP_COUNT = 7;
export const BOOT_DIAGNOSTICS_TAP_WINDOW_MS = 3000;
